export default "__VITE_ASSET__DOFFy04k__"